import {FunctionComponent} from "react";
import {makeStyles} from "tss-react/mui";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import {useHistory, useLocation} from "react-router-dom";
import {ListItemButton, Theme,} from "@mui/material";
import {useAppDispatch} from "@/Redux/Redux";
import _ from "lodash";
import CommuteIcon from "@mui/icons-material/Commute";
import Icon from "@mdi/react";
import {mdiTransfer} from "@mdi/js";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface MenuDispositionProps {
}

const useStyles = makeStyles()((theme: Theme) => ({
    listItem: {
        color: "#fff",
    },
    listItemIcon: {
        color: "#fff !important",
    },
    active: {
        backgroundColor: "#e42022!important",
        borderColor: "#e42022!important",
        fontWeight: 600,
    }
}));

const MenuDisposition: FunctionComponent<MenuDispositionProps> = (): JSX.Element => {
    const {classes, cx} = useStyles();
    const dispatch = useAppDispatch();
    const history = useHistory();

    const location = useLocation();
    const {t} = useTranslation();

    const isActive = (pathname: string, exact: boolean = false) => {
        if (exact) {
            return location.pathname === pathname;
        }
        return _.includes(location.pathname, pathname);
        //return pathname === location.pathname;
    };
    return (
        <>
            <ListItemButton
                className={cx(
                    classes.listItem,
                    isActive("/manager/disposition", true)
                        ? classes.active
                        : ""
                )}
                onClick={() => {
                    history.push("/manager/disposition");
                }}
                dense
            >
                <ListItemIcon className={classes.listItemIcon}>
                    <EventNoteOutlinedIcon/>
                </ListItemIcon>
                <ListItemText primary={t("sidebar.disposition")}/>
            </ListItemButton>
            <ListItemButton
                className={cx(
                    classes.listItem,
                    isActive(
                        "/manager/disposition/reservations",
                        true
                    )
                        ? classes.active
                        : ""
                )}
                dense
                onClick={() => {
                    history.push(
                        "/manager/disposition/reservations"
                    );
                }}
            >
                <ListItemIcon className={classes.listItemIcon}>
                    <CommuteIcon/>
                </ListItemIcon>
                <ListItemText
                    primary={t("sidebar.reservationlog")}
                />
            </ListItemButton>
            {/*<ListItemButton
                className={cx(classes.listItem, isActive('/manager/log') ? classes.active : '')}
                dense
                onClick={() => {
                    history.push("/manager/log");
                }}
            >
                <ListItemIcon className={classes.listItemIcon}>
                    <Icon path={mdiTransfer} size={1}/>
                </ListItemIcon>
                <ListItemText primary={t('sidebar.log')}/>
            </ListItemButton>*/}
        </>
    );
};

export default MenuDisposition;
